import { create } from 'zustand'

// Create the video store
export const useVideoStore = create((set, get) => ({
  // State
  recommendations: [],
  songsPlayed: 0,
  totalPlayTime: 0,
  
  // Actions
  setRecommendations: (recs) => set({ recommendations: recs }),
  setSongsPlayed: (count) => set({ songsPlayed: count }),
  setTotalPlayTime: (time) => set({ totalPlayTime: time }),
  incrementSongsPlayed: () => set(state => ({ songsPlayed: state.songsPlayed + 1 })),
  addPlayTime: (time) => set(state => ({ totalPlayTime: state.totalPlayTime + time })),
  resetStats: () => set({ songsPlayed: 0, totalPlayTime: 0 })
}))

// Initialize function for setting up the store
export const initializeVideoStore = () => {
  const store = useVideoStore.getState()
  
  // Set default recommendations if empty
  if (store.recommendations.length === 0) {
    store.setRecommendations([
      {
        id: 'rec-1',
        title: 'Popular Karaoke Songs',
        description: 'Most sung karaoke tracks',
        songs: []
      },
      {
        id: 'rec-2', 
        title: 'New Releases',
        description: 'Latest additions to our library',
        songs: []
      }
    ])
  }
  
  // Initialize stats if needed
  if (!store.songsPlayed) {
    useVideoStore.setState({ songsPlayed: 0, totalPlayTime: 0 })
  }
  
  console.log('Video store initialized successfully')
  return store
} 